// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Iz5Y","image":"Header_image__1saZe","name":"Header_name__2HzK0","info":"Header_info__3rUz4","infoRow":"Header_infoRow__laLUt"};